<template>
<div class="Preloader">
	<div class="sk-folding-cube">
		<div class="sk-cube1 sk-cube"></div>
		<div class="sk-cube2 sk-cube"></div>
		<div class="sk-cube4 sk-cube"></div>
		<div class="sk-cube3 sk-cube"></div>
	</div>
</div>
</template>
<script>

export default {
	name: 'Preloader',
	props: {
		content: {
			type: String,
			default () {
				return ""
			}
		},

	},
	data() {
		return {}
	},
	mounted() {

	},
	methods: {

	}
}
</script>

<style scoped lang="scss">
.Preloader {
	background-color: color(bg);
    display: flex;
    align-items: center;
	justify-content: center;
    position: fixed;
	z-index: zIndex(preloader);
    top: 0;
	left: 0;
	width: 100%;
	height: 100%;
    transition: all 0.225s;

}
.sk-folding-cube {
    width: 28px;
    height: 28px;

}
.Status {
    font-size: 0.75em;
    margin-left: 15px;
}
.sk-folding-cube .sk-cube {
    float: left;
    width: 50%;
    height: 50%;
    position: relative;

    transform: scale(1.1);
}
.sk-folding-cube .sk-cube:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: color(prime);
    animation: sk-foldCubeAngle 2.4s infinite linear both;
    transform-origin: 100% 100%;
}
.sk-folding-cube .sk-cube2 {
    transform: scale(1.1) rotateZ(90deg);
}
.sk-folding-cube .sk-cube3 {
    transform: scale(1.1) rotateZ(180deg);
}
.sk-folding-cube .sk-cube4 {
    transform: scale(1.1) rotateZ(270deg);
}
.sk-folding-cube .sk-cube2:before {
    animation-delay: 0.3s;
}
.sk-folding-cube .sk-cube3:before {
    animation-delay: 0.6s;
}
.sk-folding-cube .sk-cube4:before {
    animation-delay: 0.9s;
}
@keyframes sk-foldCubeAngle {
    0%,
    10% {
        -webkit-transform: perspective(140px) rotateX(-180deg);
        transform: perspective(140px) rotateX(-180deg);
        opacity: 0;
    }
    25%,
    75% {
        -webkit-transform: perspective(140px) rotateX(0deg);
        transform: perspective(140px) rotateX(0deg);
        opacity: 1;
    }
    100%,
    90% {
        -webkit-transform: perspective(140px) rotateY(180deg);
        transform: perspective(140px) rotateY(180deg);
        opacity: 0;
    }
}
@keyframes fadeIn {
    100% {
        opacity: 1;
    }
}
</style>



// WEBPACK FOOTER //
// Preloader.vue?3d5c3440